module.exports = __webpack_public_path__ + "img/xinzhuang-3.6f8b4d8c.jpg";